var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inset from 'syf-component-library/ui/spacing/Inset/Inset';
import { UserGroup, UserItemWrapper } from './subcomponents';
import { FAR_USER_CIRCLE } from '../../../../../../const/icon-props';
import { translate } from '../../../../strings/i18n';
import colors from '../../../../../../const/colors';
import Icon from '../../../../../icon';
var UserItem = function (_a) {
    var name = _a.name, isNewUserConfirmation = _a.isNewUserConfirmation;
    return (_jsxs(UserItemWrapper, __assign({ horizontal: "medium", isNewUserConfirmation: isNewUserConfirmation }, { children: [_jsxs(UserGroup, { children: [_jsx(Icon, { icon: FAR_USER_CIRCLE, title: "User Icon", size: "2x", color: colors.mediumDarkBlue }), _jsx(Inset, __assign({ left: "base" }, { children: name }))] }), !isNewUserConfirmation && _jsx("b", { children: translate('authorizedUser') })] })));
};
export default UserItem;
